import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Init from './Init';
import store from './store/store'
import { Provider } from 'react-redux'
import * as Sentry from "@sentry/react";
//import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';

Sentry.init({
    dsn: "https://3d4ff203952dee331033bdc72b8e2f44@o4508660389904384.ingest.us.sentry.io/4508676888854528",
    environment: process.env.REACT_APP_ENV,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            // NOTE: This will disable built-in masking. Only use this if your site has no sensitive data, or if you've already set up other options for masking or blocking relevant data, such as 'ignore', 'block', 'mask' and 'maskFn'.
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost"],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Auth0Provider
        domain={process.env.REACT_APP_AUTH0_DOMAIN}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
        authorizationParams={{
            redirect_uri: window.location.origin,
            audience: process.env.REACT_APP_HQ_AUTH0_AUDIENCE,
        }}
        useRefreshTokens={true}
    >
        <React.StrictMode>
            <Provider store={store}>
                <Init />
            </Provider>
        </React.StrictMode>
    </Auth0Provider>
);


//reportWebVitals();
